import { ArrowUpRight } from 'lucide-react'
import type { Article } from '../types'

interface ArticleCardProps {
  article: Article
}

export function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="article-card">
      <a className="article-card__image" href={`/${article.slug}/`} aria-label={`Read ${article.title}`}>
        <img src={article.image} alt={article.imageAlt} loading="lazy" />
      </a>
      <div className="article-card__body">
        <div className="article-card__meta">
          <span>{article.eyebrow}</span>
          <span>{article.readTime}</span>
        </div>
        <h3><a href={`/${article.slug}/`}>{article.title}</a></h3>
        <p>{article.description}</p>
        <a className="text-link" href={`/${article.slug}/`}>
          Read article <ArrowUpRight aria-hidden="true" />
        </a>
      </div>
    </article>
  )
}
